import { ClientAuthColumn, ClientAuthSettingsListCriteria, ClientAuthUsersListConfiguration, ClientAuthUsersListCriteria } from '../objects/clientAuthList';

export const CLIENT_AUTH_USERS_MODULE = 'CLIENT_AUTH_USERS';

export const EMPTY_CLIENT_AUTH_USERS_LIST_CRITERIA: ClientAuthUsersListCriteria = {
    limit: 10,
    page: 0,
    search: '',
    order: 'desc',
    order_by: 'last_activity_time',
    filters: {
        email: '',
        environment: '',
        full_name: '',
    },
};

export const EMPTY_CLIENT_AUTH_SETTINGS_LIST_CRITERIA: ClientAuthSettingsListCriteria = {
    limit: 10,
    page: 0,
};

export const DEFAULT_CLIENT_AUTH_USERS_COLUMNS: ClientAuthColumn[] = [
    { label: 'user', field_name: 'USER', checked: true, order_by: 'user', fixed_width: false, last_updated: false },
    { label: 'email', field_name: 'EMAIL', checked: true, order_by: 'email', fixed_width: false, last_updated: false },
    { label: 'environment', field_name: 'ENVIRONMENT', checked: true, order_by: 'authorized_environment', fixed_width: true, last_updated: false },
    { label: 'status', field_name: 'STATUS', checked: true, order_by: 'last_activity_time', fixed_width: true, last_updated: false },
    { label: 'last-activity', field_name: 'LAST_ACTIVITY', checked: true, order_by: 'last_activity_time', fixed_width: true, last_updated: false },
    { label: 'last-url', field_name: 'LAST_URL', checked: true, order_by: '', fixed_width: false, last_updated: false },
    { label: 'expires', field_name: 'EXPIRES', checked: true, order_by: 'expires', fixed_width: true, last_updated: false },
];

export const EMPTY_CLIENT_AUTH_USERS_LIST_CONFIGURATION: ClientAuthUsersListConfiguration = {
    columns: DEFAULT_CLIENT_AUTH_USERS_COLUMNS,
    preferences: [],
};
